/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmCsrVoteModuleViewProps } from './mfrm-csr-vote-module';

export default (props: IMfrmCsrVoteModuleViewProps) => {
    const { csrHeaderImage, csrHeader, csrContent, ctaButton } = props;

    return (
        <div className='row d5-mfrm-csr-vote-module '>
            <div className='d5-mfrm-csr-vote-module__module-container'>
                <div>
                    {csrHeaderImage}
                    {csrHeader}
                    {csrContent}
                    {ctaButton}
                </div>

            </div>
        </div>
    );
};
